// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/edit-profile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/password.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assets/Images/container.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Assets/Images/team.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../Assets/Images/subscriptions.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../Assets/Images/delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../Assets/Svgs/logout-blue.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configuration-container {
  width: 800px;
}

.configuration-content {
  padding: 30px 24px 30px 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.configuration-content p {
  padding: 6px 16px 6px 16px;
  font-size: 14px;
}

.configuration-divisor {
  border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
  padding-top: 16px;
}

.configuration-element {
  cursor: pointer;
}

.configuration-disabled {
  opacity: 0.6;
  cursor: no-drop;
}

.configuration-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.configuration-content .form-group {
  margin-bottom: 0px;
}

.configuration-content .form-group label {
  color: #141718;
}

.configuration-active {
  border: 2px solid #0084FF;
  border-radius: 20px;
  padding: 6px 4px 6px 38px !important;
  background-position: 14px center !important;
  color: #141718;
  font-weight: 600;
  opacity: 1 !important;
}

.edit-profile-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.password-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.notification-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.chat-export-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.applications-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.team-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.manage-subscription-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
}

.delete-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
  color: #D84C10;
}

.logout-menu .configuration-element p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: 16px center;
  padding: 8px 16px 8px 40px;
  line-height: 24px;
  color: #141718;
  font-weight: 600;
  opacity: 0.75;
  color: #3E90F0;
}

.delete-menu .configuration-element p.configuration-active {
  border-color: #D84C10;
  color: #D84C10;
}`, "",{"version":3,"sources":["webpack://./src/Components/Configuration/configuration.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,0BAAA;EACA,eAAA;AACF;;AAEA;EACE,iDAAA;EACA,iBAAA;AACF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2CAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AAFF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AAFF;;AAKA;EACE,qBAAA;EACA,cAAA;AAFF","sourcesContent":[".configuration-container {\n  width: 800px;\n}\n\n.configuration-content {\n  padding: 30px 24px 30px 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n}\n\n.configuration-content p {\n  padding: 6px 16px 6px 16px;\n  font-size: 14px;\n}\n\n.configuration-divisor {\n  border-top: 1px solid #0000001a;\n  padding-top: 16px;\n}\n\n\n\n.configuration-element {\n  cursor: pointer;\n}\n\n.configuration-disabled {\n  opacity: 0.6;\n  cursor: no-drop;\n}\n\n.configuration-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.configuration-content .form-group {\n  margin-bottom: 0px;\n}\n\n.configuration-content .form-group label {\n  color: #141718;\n}\n\n.configuration-active {\n  border: 2px solid #0084FF;\n  border-radius: 20px;\n  padding: 6px 4px 6px 38px !important;\n  background-position: 14px center !important;\n  color: #141718;\n  font-weight: 600;\n  opacity: 1 !important;\n\n}\n\n.edit-profile-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/edit-profile.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.password-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/password.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.notification-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/edit-profile.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.chat-export-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/edit-profile.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.applications-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/container.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.team-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/team.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.manage-subscription-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/subscriptions.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.delete-menu .configuration-element p {\n  background-image: url(\"../../Assets/Images/delete.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n  color: #D84C10\n}\n\n.logout-menu .configuration-element p {\n  background-image: url(\"../../Assets/Svgs/logout-blue.svg\");\n  background-repeat: no-repeat;\n  background-position: 16px center;\n  padding: 8px 16px 8px 40px;\n  line-height: 24px;\n  color: #141718;\n  font-weight: 600;\n  opacity: 0.75;\n  color: #3E90F0;\n}\n\n.delete-menu .configuration-element p.configuration-active {\n  border-color: #D84C10;\n  color: #D84C10\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
